<script>
    export default {
        methods: {
            msg_error_dialog(message) {
                console.log(message);
                if (Array.isArray(message)) {
                    this.$dialog.error({ // vuetify-dialog https://www.npmjs.com/package/vuetify-dialog
                        text: message.join('<br>'),
                        title: 'エラー',
                        color: 'error',
                        actions: { false: '閉じる' },
                    });
                } else {
                    this.$dialog.error({
                        text: message,
                        title: 'エラー',
                        color: 'error',
                        actions: { false: '閉じる' },
                    });
                }
            },
            async msg_info(message) {
                const res = await this.$dialog.confirm({
                    text: message,
                    title: '情報',
                    actions: { false: '閉じる' },
                    color: 'primary',
                });

                return res;
            },
            async msg_confirm(message) {
                const res = await this.$dialog.confirm({
                    text: message,
                    title: '確認',
                    color: 'primary',
                    actions: {
                        false: 'キャンセル',
                        true: 'OK',
                    },
                });

                return res;
            },
            notify_info(message) {
                this.$dialog.notify.info(message, {
                    position: 'bottom-right',
                    timeout: 3000,
                });
            },
        },
    };
</script>
